const { parse: parseUrl } = require('url');
const isPlainObject = require('./isPlainObject');

const santizeFields = ['url', 'icon'];

const sanitizeUrl = (value, key) => {
  if (!santizeFields.includes(key)) {
    return value;
  }
  const { protocol } = parseUrl(value);
  // eslint-disable-next-line no-script-url
  return protocol && protocol.includes('javascript:') ? 'about:blank' : value;
};

const sanitizeObject = (value, key) => {
  if (Array.isArray(value)) {
    return value.map(sanitizeObject);
  }

  if (isPlainObject(value)) {
    return Object.keys(value).reduce(
      (acc, field) => ({
        ...acc,
        [field]: sanitizeObject(value[field], field),
      }),
      {}
    );
  }

  return sanitizeUrl(value, key);
};

const sanitizeContent = (content) => sanitizeObject(content);

module.exports = sanitizeContent;
